import { Routes } from './enums'

export function toPath(route: Routes | string): string {
    return `/${route}`
}
